import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http'
import { environment } from '../../environments/environment'
import { SharedService } from '../Shared/Services/shared.service';

@Injectable({
  providedIn: 'root'
})
export class ContractsWarrantiesService {
  readonly APIurl = environment.apiUrl;

  constructor(private http: HttpClient, private shared: SharedService) { }

  GetAllContracts() {
    return this.http.get(`${this.APIurl}/Contract/GetAllContractByWorkShop2`, this.shared.options);
  }

  GetAllContractByClient() {
    return this.http.get(`${this.APIurl}/Contract/GetAllContractByClient`, this.shared.options);
  }

  GetContractDetails(ContractId?: number) {
    return this.http.get(`${this.APIurl}/Contract/GetContractInfoByContractId?contractId=${ContractId}`, this.shared.options);
  }

  GetAllWarranties() {
    return this.http.get(`${this.APIurl}/Warranty/getWarrantiesListForWorkshop`, this.shared.options);
  }

  GetAllWarrantyByClientId() {
    return this.http.get(`${this.APIurl}/Warranty/GetAllWarrantyByClientId`, this.shared.options);
  }

  GetWarrantyDetails(GuaranteId?: number) {
    return this.http.get(`${this.APIurl}/Warranty/GetWarrantyInfoById?warrantyId=${GuaranteId}`, this.shared.options);
  }

  CostCalcToClient(ClientId?: number) {
    return this.http.get(`${this.APIurl}/CostCalcToClient/GetCostCalcAssignClientId?ClientId=${ClientId}`, this.shared.options);
  }

  CreateContract(data: any) {
    return this.http.post(`${this.APIurl}/Contract/CreateContract`, data, this.shared.options);
  }

  GetContractNumber() {
    return this.http.get(`${this.APIurl}/Contract/GetContractNumber`, this.shared.options);
  }
}
